export interface DefaultRouteState {
  actualRoutes: any[];
  recentRoutes: any[];
  drivers: [];
  templates: any[];
  declarationFormInformation?: RouteDeclarationFormInformation;
  loadingTemplates: boolean;
  loadingRecentRoutes: boolean;
  loadingActualRoutes: boolean;
  loadingDeclarationFormInformation: boolean;
}

export const defaultRouteState: DefaultRouteState = {
  actualRoutes: [],
  recentRoutes: [],
  drivers: [],
  templates: [],
  loadingTemplates: false,
  loadingRecentRoutes: false,
  loadingActualRoutes: false,
  loadingDeclarationFormInformation: false
};

export interface RouteDeclarationFormInformation {
  maxKmRange: number;
  kmRangeUntilReasonRequired: number;
  commentOptions: string[];
}
